// extracted by mini-css-extract-plugin
export default {"container":"RadioGroupDocumentation_container__t7zfD","exampleNote":"RadioGroupDocumentation_exampleNote__J6sTU","customRadioGroup":"RadioGroupDocumentation_customRadioGroup__IVfTu"};